import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axiosInstance from "../../../utils/axiosInstance";
import { create_users } from "../../shared/ApiEndpoint";
import { userModal } from "../../shared/validation";
import { notification } from "antd";



function CreateUserModal({
  show,
  setShow,
  fetch_Users,
  searchTerm,
  currentPage,
  selectedRoleId,
  roles
}) {
  const handleClose = () => {
    setShow(false);
    setNewUser(initialState); // Reset form
  };

  const initialState = {
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    role: "",
    phone_no: "",
    password: "",
  };
  const [newUser, setNewUser] = useState(initialState);
  const [errorValidate, setErrorValidate] = useState({
    first_name: false,
    last_name: false,
    username: false,
    email: false,
    role: false,
    phone_no: false,
    password: false,
  });



  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setNewUser({ ...newUser, [name]: value });

    if(value.trim()!==""){
      setErrorValidate((prev) => ({ ...prev, [name]:false}));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid=true;

    const validations={
      first_name: !newUser.first_name,
      last_name: !newUser.last_name,
      username: !newUser.username,
      email: !newUser.email,
      role: !newUser.role,
      phone_no: !newUser.phone_no,
      password: !newUser.password,
    }

 Object.entries(validations).forEach(([key, hasError]) => {
    if(hasError) isValid = false;
  })

  setErrorValidate((prev) => ({
    ...prev,
    ...validations
  }))
  if(!isValid) return;

    const payload = {
      ...newUser,
    };

    try {
      const resp = await axiosInstance.post(create_users, payload, {
        withCredentials: true,
      });

      if (resp?.status === 200) {
        if(resp?.data?.message){
          console.log(resp.data.message)
        }
         notification.success({
        key: 'register-success',
        description: 'User registered successfully!',
        placement: 'topRight',
      });
        setShow(false);
        setNewUser(initialState);
        fetch_Users(searchTerm, currentPage, selectedRoleId);

      }
    }catch (error) {
  const status = error?.response?.status;
  const message = error?.response?.data?.message;

  console.log("❌ Error while creating user:", message || error);

  if (status === 400) {
    notification.error({
      key: 'register-error',
      description: 'User already exists!',
      placement: 'topRight',
    });
  } else {
    notification.error({
      key: 'register-error',
      description: 'Registration failed. Please try again.',
      placement: 'topRight',
    });
  }
}
  };

  return (
    <Modal show={show} onHide={handleClose} centered style={{ zIndex: 2000 }}>
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Create User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-3">
            <div className="col-md-6">
              <label htmlFor="first_name" className="form-label">First Name <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                id="first_name"
                name="first_name"
                value={newUser.first_name}
                onChange={handleOnChange}
                placeholder="Enter First Name"
              />
              {errorValidate.first_name && (
                <div className="text-danger">{userModal.first_name}</div>
              )}
            </div>
            <div className="col-md-6">
              <label htmlFor="last_name" className="form-label">Last Name</label>
              <input
                type="text"
                className="form-control"
                id="last_name"
                name="last_name"
                value={newUser.last_name}
                onChange={handleOnChange}
                placeholder="Enter Last Name"
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-6">
              <label htmlFor="username" className="form-label">Username <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                id="username"
                name="username"
                value={newUser.username}
                onChange={handleOnChange}
                placeholder="Enter Username"
              />
              {errorValidate.username && (
                <div className="text-danger">{userModal.username}</div>
              )}
            </div>
           <div className="col-md-6">
  <label htmlFor="role" className="form-label">Role <span className="text-danger">*</span></label>
  <select
    className="form-select"
    id="role"
    name="role"
    value={newUser.role}
    onChange={handleOnChange}
  >
    <option value="">Select a Role</option>
    {roles.map((roleItem) => (
      <option key={roleItem.role_id} value={roleItem.role_id}>
        {roleItem.rolename}
      </option>
    ))}
  </select>
  {errorValidate.role && (
  <div className="text-danger">{userModal.role}</div>
)} 
</div>


          </div>

          <div className="row mb-3">
            <div className="col-md-6">
              <label htmlFor="email" className="form-label">Email <span className="text-danger">*</span></label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={newUser.email}
                onChange={handleOnChange}
                placeholder="Enter Email"
              />
               {errorValidate.email && (
                <div className="text-danger">{userModal.email}</div>
              )}
            </div>
           
               <div className="col-md-6">
              <label htmlFor="phone_no" className="form-label">Phone Number <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                id="phone_no"
                name="phone_no"
                value={newUser.phone_no}
                onChange={handleOnChange}
                placeholder="Enter Phone Number"
              />
               {errorValidate.phone_no && (
                <div className="text-danger">{userModal.phone_no}</div>
              )}
            </div>
           
          </div>

          <div className="row mb-3">
         <div className="col-md-12">
            <label htmlFor="password" className="form-label">Password <span className="text-danger">*</span></label>
            <input
              type="password"
              className="form-control"
              id="password"
              name="password"
              value={newUser.password}
              onChange={handleOnChange}
              placeholder="Enter Password"
            />
         </div>
         {errorValidate.password && (
                <div className="text-danger">{userModal.password}</div>
              )}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Create
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default CreateUserModal;
